import i18n from "@/lang";

const wordsMap = {
  'coins': () => { return i18n.t('lang.commonM.k295') },
}

export function getEchoWords () {
  const tempWordsObj = {}

  Object.keys(wordsMap).forEach(wordKey => {
    tempWordsObj[wordKey] = wordsMap[wordKey]()
  })

  return tempWordsObj
}

export default getEchoWords